import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UserMenuComponent } from './shared/user-menu/user-menu.component';
import { LayoutsModule } from './layouts/layouts.module';
import { LoginComponent } from './auth/login/login.component';
import { EmailVerifyComponent } from './auth/email-verify/email-verify.component';
import { EmailResetPasswordComponent } from './auth/email-reset-password/email-reset-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SignUpComponent } from './auth/signup/signup.component';
import { SignUpSuccessComponent } from './auth/signup-success/signup-success.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxUiLoaderConfig, NgxUiLoaderModule, NgxUiLoaderRouterModule, SPINNER } from 'ngx-ui-loader';
import { NotLoggedInComponent } from './auth/not-logged-in/not-logged-in.component';
import { PasswordResetComponent } from './auth/password-reset/password-reset.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { JwtModule } from '@auth0/angular-jwt';
import { TokenInterceptor } from './services/token-interceptor.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TablePaginationComponent } from './shared/table-pagination/table-pagination.component';
import { UiModule } from './UI/ui/ui.module';
import { GetImage } from './helpers/getImage';

declare const require: any;

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#OOACC1',
  bgsOpacity: 0.5,
  bgsType: SPINNER.rectangleBounce,
  fgsColor: '#337AB7',
  fgsType: SPINNER.ballScaleMultiple,
};

@NgModule({
  declarations: [
    AppComponent,
    UserMenuComponent,
    LoginComponent,
    EmailVerifyComponent,
    EmailResetPasswordComponent,
    SignUpComponent,
    SignUpSuccessComponent,
    PasswordResetComponent,
    NotLoggedInComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LayoutsModule,
    FormsModule,
    HttpClientModule,
    NgxUiLoaderModule,
    NgxUiLoaderRouterModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    UiModule,
    NgxFileDropModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem('access_token_automap');
        },
      },
    }),
  ],
  providers: [
    GetImage,
    TablePaginationComponent,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
  exports: [ReactiveFormsModule],
  bootstrap: [AppComponent],
})
export class AppModule {}
